import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import StorePublic from './StorePublic';
import StoreCheckout from './StoreCheckout';
import VCardPublic from './VCardPublic';
import { getBackendUrl } from '../../lib/env';

const API_URL = getBackendUrl();

export default function CustomDomainRouter() {
  const location = useLocation();
  const [resolved, setResolved] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    axios.get(`${API_URL}/api/public/domains/resolve`, {
      params: {
        host: window.location.hostname,
        path: location.pathname,
        product: new URLSearchParams(location.search).get('product') || '',
        product_slug: new URLSearchParams(location.search).get('product_slug') || '',
      },
    })
      .then((response) => {
        if (!cancelled) setResolved(response.data || null);
      })
      .catch(() => {
        if (!cancelled) setResolved(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [location.pathname, location.search]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
        <div className="w-8 h-8 border-2 border-emerald-700 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!resolved) {
    return (
      <div className="min-h-screen bg-[radial-gradient(circle_at_top,_rgba(16,185,129,0.08),_transparent_34%),linear-gradient(180deg,#f8fafc_0%,#eff6ff_100%)] flex items-center justify-center p-4">
        <Card className="w-full max-w-xl bg-white border border-slate-200 rounded-[28px] shadow-sm">
          <CardContent className="p-8 text-center space-y-4">
            <p className="text-lg font-semibold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>Domain not configured</p>
            <p className="text-sm text-slate-500">This domain is not active yet or has not been connected to a store.</p>
            <Button className="bg-emerald-700 hover:bg-emerald-800 text-white" onClick={() => window.location.reload()}>
              Try again
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (resolved.route_type === 'vcard_home') {
    return <VCardPublic resolvedUsername={resolved.username} />;
  }

  if (resolved.route_type === 'store_checkout') {
    return <StoreCheckout resolvedUsername={resolved.username} resolvedProductSlug={resolved.product_slug || new URLSearchParams(location.search).get('product') || ''} publicPathPrefix="" />;
  }

  return <StorePublic resolvedUsername={resolved.username} resolvedProductSlug={resolved.route_type === 'store_product' ? resolved.product_slug : ''} publicPathPrefix="" />;
}
